<template>
<div class="chapter">
<div class="inner_page">
<p class="partno"><a id="page_1"><i>PART ONE</i></a></p><a id="page_1">
<p class="parttitle">DESCENT INTO DARKNESS</p>
<p class="imagea"><img alt="images" src="images/sta.png"/></p>
<p class="parttitlea"><b>1997-2001</b></p>
<p class="ded"><i>“Darkness cannot drive out darkness, only light can do that.”</i></p>
<p class="deda"><b>–M<span class="small">ARTIN</span> L<span class="small">UTHER</span> K<span class="small">ING</span>, J<span class="small">R</span>.</b></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12_Part01.vue?b74f9212